import { useTranslation } from "react-i18next";
import { AppointmentPackageSection } from "@/components/calendar/AppointmentPackageSection";
import type { AppointmentDetailsController } from "@/components/calendar/useAppointmentDetailsController";

export function AppointmentPackagesCard({ ctrl }: { ctrl: AppointmentDetailsController }) {
  const { t } = useTranslation("calendar");
  const {
    appointment,
    activePetId,
    packageDrafts,
    handlePackageDraftChange,
    isPackageSectionLocked,
    hasActiveSale,
  } = ctrl;

  if (hasActiveSale) return null;

  return (
    <AppointmentPackageSection
      clinicId={appointment?.clinic_id ?? ""}
      petId={activePetId}
      values={packageDrafts}
      appointmentType={appointment?.clinic_appointment_type?.behavior ?? "padrao"}
      disabled={isPackageSectionLocked}
      isRecurring={Boolean(appointment?.recurrence_id)}
      readOnly={hasActiveSale}
      onChange={handlePackageDraftChange}
    />
  );
}
